import React, { useEffect } from "react";
import { StyleSheet } from "react-native";
import { genderList } from "src/constant";
import { FormControlLabel } from "src/components";
import { colors } from "src/assets";
import { EventRegister } from "react-native-event-listeners";
import { navigationRef } from "src/hooks/navigation";
import { IAddress } from "src/domains";
import { MyAddressChangeEvent } from "src/utils/event";
import LocalText from "src/local";

export type AddressProps = {
  value?: IAddress;
  error?: string;
  onChange: (value: IAddress) => void;
};

const buildDetail = (v?: IAddress) => {
  let text = "";
  if (v) {
    if (v.postnumber) {
      if (v.postnumber.length === 7) {
        text += `〒${v.postnumber.substring(0, 3)}-${v.postnumber.substring(
          3,
          7
        )}`;
      } else {
        text += `〒${v.postnumber} `;
      }
    }
    if (v.prefecture) {
      text += `\n ${v.prefecture}`;
    }
    if (v.city) {
      text += `${v.city}`;
    }
    if (v.address) {
      text += ` ${v.address}`;
    }
    if (v.address2) {
      text += `\n ${v.address2}`;
    }
  }

  return text || LocalText.common.unselected;
};

export const Address: React.FC<AddressProps> = ({ value, error, onChange }) => {
  useEffect(() => {
    const myAddressChangeListener = EventRegister.addEventListener(
      MyAddressChangeEvent,
      (v: any) => onChange(v.address)
    );
    return () => {
      EventRegister.removeEventListener(myAddressChangeListener as string);
    };
  }, [onChange]);

  return (
    <FormControlLabel
      text={LocalText.screens.myProfile.address.title}
      helper={LocalText.screens.myProfile.address.helper}
      detailStyle={[value?.address ? styles.detail : {}]}
      detail={buildDetail(value)}
      rightIcon={"chevron"}
      error={error}
      onPress={() => {
        navigationRef.current?.navigate("MyAddress", {
          address: value,
        });
      }}
    />
  );
};

const styles = StyleSheet.create({
  detail: {
    color: colors.chokuBlack,
  },
});
